
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { uiActions, visualizerActions } from "../../store";
import { getJsonFromSheet } from '../../Helpers/SheetsHelper';
import PaintPackage from '../PaintPackage/PaintPackage';
import GarageDoorSurfaces from '../GarageDoorSurfaces/GarageDoorSurfaces';
import ShutterSurfaces from '../ShutterSurfaces/ShutterSurfaces';

import styles from "./ExteriorPaint.module.css";

export default function ExteriorPaint() {
    const dispatch = useDispatch();
    const [packageData, setPackageData] = useState(null);
    const [selectedPackageData, setSelectedPackageData] = useState(null);

    const [shuttersFlag, setShuttersFlag] = useState(false);
    const [garageDoorFlag, setGarageDoorFlag] = useState(false);
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const activePackage = useSelector((state) => state.visualizer.activePackage);
    const activePlan = useSelector((state) => state.visualizer.activeFloorPlanData);
    const activeCommunity = useSelector((state) => state.visualizer.activeCommunity);
    const shouldShowGarageShuttersSection = garageDoorFlag || shuttersFlag;
    const bodySurfaces = ["Walls"];
    const trimSurfaces = ["Trim","Door Trim"];
    const doorSurfaces = ["Door", "Sidelight","Sidelights"];

    useEffect(() => {
        getJsonFromSheet('/data/Schemes.xlsx', activeCommunity).then(packages => {
            // setPackageData(packages); // Set the package data once it's available
            //const packageDataFiltered = packages.filter(p => p["Community"] === activePlan['extScheme'])
            //setPackageData(packageDataFiltered);
            setPackageData(packages);
        });
    }, []); // Empty dependency array to run only once


    // useEffect to run applyPackage whenever selectedPackageData is updated
    useEffect(() => {
        if (selectedPackageData) {
            applyPackage();
        }
    }, [selectedPackageData]); // This will re-run applyPackage when selectedPackageData changes

    const handlePackageSelect = (e) => {
        const { name, value } = e.target;
        
        // Find the first matching package based on the scheme
        let selectedPackageData = packageData.find(p => p.scheme === value);
        if (selectedPackageData) {
            // Set the selected package data
            setSelectedPackageData(selectedPackageData);
            dispatch(visualizerActions.setSelection(selectedPackageData.scheme));
            dispatch(visualizerActions.setActivePackage(selectedPackageData));
        }
    };
    
    const handleSurfaceSelect = (e) => {
        if (!selectedPackageData)
            return;
        const { name, value} = e.target;
        // Get the data-surface-name attribute value
        const surfaceName = e.target.getAttribute('data-surface-name');
        const mapper = {
            'TRIM':'trimChamID',
            'DOOR':'frontDoorChamID',
            'BODY':'bodyChamID'
        }

        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if(this.name.toLowerCase() == surfaceName.toLowerCase()){
                let sel = value == 'Standard White' ?  5432257 : selectedPackageData[ mapper[value] ];
                if(sel != this.sel){
                    dispatch(uiActions.setVizLoading(true))
                    return sel
                }
            }
        });
    }

    const applyPackage = () => {
        console.log('applying package')
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            dispatch(uiActions.setVizLoading(true))

            if(this.name === "Garage Door"){
                setGarageDoorFlag(true);
                return 5432257
            } 
            if(this.name === "Shutters") setShuttersFlag(true);
            
            if(bodySurfaces.includes(this.name)) return selectedPackageData.bodyChamID;
            if(trimSurfaces.includes(this.name)) return selectedPackageData.trimChamID;
            if(doorSurfaces.includes(this.name)){
                var door = this.sel.split("(")[0];
                return `${door}(${selectedPackageData.frontDoorChamID})`;
            } 
        },true);
        
    }


    return <div className={styles.content}>
        
    <div className={styles.paintHeader}>
    {garageDoorFlag || shuttersFlag &&
        <>
            <p>1. Choose Color Scheme</p>
        </>
    }
    </div>
    <div className={styles.schemes}>
        <PaintPackage selected={activePackage?.scheme ?? -1} packageData={packageData}  handlePackageSelect={handlePackageSelect} />
    </div>
    

    {shouldShowGarageShuttersSection  &&
        <>
            <div className={styles.garageShutters}>
                <p>2. Match Colors for Garage Door & Shutters</p>

                {garageDoorFlag && (
                    <GarageDoorSurfaces
                        key={`${selectedPackageData.scheme}_GarageDoorSurfaces`}
                        packageData={selectedPackageData}
                        handleSurfaceSelect={handleSurfaceSelect}
                    />
                )}

                {shuttersFlag && (
                    <ShutterSurfaces
                        key={`${selectedPackageData.scheme}_ShutterSurfaces`}
                        packageData={selectedPackageData}
                        handleSurfaceSelect={handleSurfaceSelect}
                    />
                )}
            </div>
        </>
    }

</div>

};